import { Box, styled } from "@mui/material";

/* Container that occupied space */
const SideMenuSpaceHolder = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isCollapse",
})<{ isCollapse: boolean }>(({ isCollapse }) => ({
  display: "block",
  width: 320,
  height: "100vh",
  zIndex: 2,
  "@keyframes instantCollapseSpace": {
    "100%": {
      width: 78,
    },
  },

  ...(isCollapse && {
    animation: "instantCollapseSpace 0.1s forwards",
    /* Will wait until side-menu animation is done */
    animationDelay: "0.1s",
  }),
}));

const SideMenuContainer = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "isDeskTopMenuCollapse" && prop !== "isMobileMenuCollapse",
})<{ isDeskTopMenuCollapse: boolean; isMobileMenuCollapse: boolean }>(
  ({ theme, isDeskTopMenuCollapse, isMobileMenuCollapse }) => ({
    //side menu basic style
    backgroundColor: theme.palette.background.paper,
    width: 320,
    top: 0,
    left: 0,
    bottom: 0,
    transition: "width 0.2s 0.1s cubic-bezier(0.0, 0.0, 0.2, 1)",
    position: "fixed",
    zIndex: 2,
    height: "100%",
    minHeight: "100vh",
    boxShadow: "rgba(0, 0, 0, 0.1) 2px 0 5px 6px",

    ...(isDeskTopMenuCollapse && {
      width: 78,
      overflow: "hidden",
    }),

    ...(isMobileMenuCollapse && {
      width: 0,
    }),
  }),
);

const SideMenuContent = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isCollapse",
})<{ isCollapse: boolean }>(({ isCollapse }) => ({
  opacity: 1,
  transition: "opacity 0.2s cubic-bezier(0.0, 0.0, 0.2, 1)",
  transitionDelay: "0.3s",

  ...(isCollapse && {
    opacity: 0,
    transitionDelay: "0s",
  }),
}));

const LogoContainer = styled(Box)(() => ({
  height: 125,
  padding: 30,
}));

const SideMenuDivider = styled(Box)(() => ({
  width: "calc(100%-32px)",
  margin: "0 16px",
  height: 1,
  backgroundColor: "#e9e9e9",
}));

export {
  SideMenuSpaceHolder,
  SideMenuContainer,
  SideMenuContent,
  LogoContainer,
  SideMenuDivider,
};
